<script context="module" lang="ts">
  export var id = 0;
  export const getId = (name: string) => {
    id += 1;
    return `${name} ${id}`;
  };

  export const defaultSettings: TReviewSettings = {
    stars: 5,
    minimal: false,
    bottomAuthor: false,
    style: "",
  };
</script>

<script lang="ts">
  import ComponentContainer from "../ComponentContainer/ComponentContainer.svelte";
  import type {
    TComponentContainerSettings,
    TTag,
  } from "../ComponentContainer/types";
  import type { TReviewProps, TReviewSettings } from "./types";

  interface $$Props extends TReviewProps {}

  // Variables
  export let id: string;
  export let tag: TTag = "Review";
  export let settings: Partial<TReviewSettings> | {} = {};
  export let container: Partial<TComponentContainerSettings> | {} = {};

  var _settings = {
    ...defaultSettings,
    ...settings,
  };
</script>

<ComponentContainer settings={container} {tag} {id} let:prefix>
  <div class="container" style={_settings.style}>
    <div class="header-container" class:minimal={_settings.minimal}>
      <div class="title-container">
        <p class="title">Best app ever.</p>
        {#if !_settings.minimal}
          <p class="date author">Dec 15</p>
        {/if}
      </div>

      <div class="info">
        <div class="star-container">
          {#each Array(_settings.stars) as _}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <g class="nc-icon-wrapper" fill="currentColor">
                <path
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                />
              </g>
            </svg>
          {/each}
        </div>
        {#if !_settings.minimal}
          <p class="author">Jane Doe</p>
        {/if}
      </div>
    </div>
    <p class="body">
      In labore deserunt culpa qui ex amet aliqua aliquip non nulla ad cupidatat
      ipsum quis duis.
    </p>
    {#if _settings.bottomAuthor}
      <div class="author-container">
        <img
          class="bottom-author-icon"
          alt="author icon"
          src="../public/assets/profile-grey.svg"
        />
        <p class="bottom-author">Jane Doe</p>
      </div>
    {/if}
  </div>
</ComponentContainer>

<style>
  .author-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: calc(var(--sw-spacing) * 1.5);
    gap: calc(var(--sw-spacing));
    justify-content: flex-start;
  }

  .container {
    text-align: left;
  }

  .title-container {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
  }

  .title {
    font-weight: 600;
  }

  .title {
    font-size: calc(var(--sw-font-size) * 1.2);
  }

  .body {
    font-size: calc(var(--sw-font-size) * 1.1);
    line-height: calc(var(--sw-font-size) * 1.5);
  }

  .author {
    font-size: calc(var(--sw-font-size) * 0.95);
    opacity: 0.5;
    font-weight: inherit;
    white-space: nowrap;
  }

  .star-container {
    color: #eed358;
    display: flex;
    align-items: center;
    justify-content: left;
    margin-left: -3px;
  }

  .info {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-container {
    margin-bottom: calc(var(--sw-spacing));
  }

  .minimal {
    display: flex;
    gap: calc(var(--sw-spacing) * 0.6);
    flex-direction: column-reverse;
    align-items: flex-start;
    margin-bottom: calc(var(--sw-spacing) * 0.4);
  }
</style>
